import { Box, Typography } from "@mui/material";

/** Stands in for the tool activity a transcript-only surface hides. */
const WorkingIndicator = () => (
  <Box
    role="status"
    aria-live="polite"
    sx={{ display: "flex", alignItems: "center", gap: 1.25, py: 0.5 }}
  >
    <Box
      aria-hidden
      sx={{
        display: "flex",
        gap: "5px",
        "& > span": {
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: "text.disabled",
          animation: "workingDot 1.4s ease-in-out infinite",
        },
        "& > span:nth-of-type(2)": { animationDelay: "0.18s" },
        "& > span:nth-of-type(3)": { animationDelay: "0.36s" },
        "@keyframes workingDot": {
          "0%, 70%, 100%": { opacity: 0.35, transform: "translateY(0)" },
          "35%": { opacity: 1, transform: "translateY(-2px)" },
        },
        "@media (prefers-reduced-motion: reduce)": {
          "& > span": { animation: "none", opacity: 0.6 },
        },
      }}
    >
      <span />
      <span />
      <span />
    </Box>
    <Typography variant="body2" sx={{ color: "text.secondary" }}>
      Working…
    </Typography>
  </Box>
);

/** Stands in for a finished turn that left a transcript-only reader nothing. */
export const NoReplyLine = () => (
  <Typography variant="body2" sx={{ color: "text.secondary", py: 0.5 }}>
    No reply came through. Try sending that again.
  </Typography>
);

export default WorkingIndicator;
